import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { EntryEmailTaskFailActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function EntryEmailTaskFail({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as EntryEmailTaskFailActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》邮件发送失败</ItemWrapper>
}
